import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forEach } from "lodash";
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

const UploadArea = ({
  className,
  width,
  height,
  onChange,
  qtyFiles = 1,
  buttonLabel,
  error,
}) => {
  const inputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const handleChange = (e) => {
    let auxArray = [];
    for (let file of inputRef.current.files) {
      if (auxArray.length == qtyFiles) {
        toast.error(
          "Você selecionou uma quantidade de arquivos acima da permitida, caso queira, substitua algum já enviado pelo novo."
        );
        break;
      }
      auxArray.push(file);
    }
    setFiles(auxArray);
    onChange && onChange(auxArray);
  };
  const removeFile = (file) => {
    setFiles((prevState) => prevState.filter((f) => f.name !== file.name));
  };

  return (
    <div className={className}>
      <button onClick={() => inputRef.current.click()}>
        Selecionar arquivo(s) {"de " + buttonLabel || ""}:
        <FontAwesomeIcon className="ml-2" icon="file-arrow-up" />
      </button>
      <input
        onChange={(e) => handleChange(e)}
        type="file"
        ref={inputRef}
        name="authorization"
        multiple
      />
      <div className="files-container">
        <p>Arquivos Enviados:</p>
        {files.length == 0 ? (
          <p style={{ width: "100%", textAlign: "center", color: "gray" }}>
            Nenhum arquivo selecionado
          </p>
        ) : (
          files.map((f) => {
            return (
              <div>
                <span>{f.name}</span>
                <span>
                  {(f.size / (1024 * 1024)).toFixed(2)}
                  MB
                </span>
                <span>
                  <FontAwesomeIcon
                    style={{ cursor: "pointer" }}
                    icon="trash"
                    color="white"
                    onClick={() => removeFile(f)}
                  />
                </span>
              </div>
            );
          })
        )}
      </div>
      {error && <label className="error-label">{error}</label>}
    </div>
  );
};

export default styled(UploadArea)`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "200px"};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;

  button {
    width: 300px;
    height: 30px;
    background-color: #499d96;
    color: white;
    font-weight: 600;
    border: none;
    cursor: pointer;
    &:hover {
      background-color: #316965ff;
    }
  }
  input {
    width: 100%;
    height: 200px;
    display: none;
  }

  .files-container {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    p {
      width: 100%;
      text-align: left;
    }
    div {
      padding: 20px;
      width: 100%;
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: rgb(73, 157, 150);
      background: rgb(73, 157, 150);
      background: linear-gradient(
        90deg,
        rgba(73, 157, 150, 1) 3%,
        rgba(21, 195, 181, 1) 100%
      );
      border-radius: 5px;
      span {
        color: white;
        font-weight: 500;
      }
    }
  }
  .error-label {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #c14646ff;
  }
`;
